import React, { useState, useContext, JSX } from 'react'
import { Handle, Position, useReactFlow } from '@xyflow/react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import { Tool } from "../../../../../types/entities";
import BuildIcon from '@mui/icons-material/Build';
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import SettingsIcon from '@mui/icons-material/Settings';


function WorkflowToolNode({ id, data }: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    let fullTool: Tool = undefined;
    for (let i: number = 0; i < context.tools.length; i++) {
        let tool: Tool = context.tools[i];
        if (tool.operatorToolId.toString() === data.toolId) {
            fullTool = tool;
            break;
        }
    }

    function handleToolConfigurationClick(tool: Tool): void {
        context.setEditingTool(tool, data.workflowId);
    }

    if (fullTool === undefined) {
        return (
            <div className="workflow-node tool">
                <Handle type="target" position={Position.Left} />
                <span>{ "Unable to load the tool" }</span>
            </div>
        );
    }


    return (
        <div className={ "workflow-node tool " + id + " " } >
            <Handle type="target"  position={Position.Left} />
            <div className='tool__tool'>
                { (fullTool.customParameters !== undefined && fullTool.customParameters !== 'null' && fullTool.customParameters !== '') &&
                    <div className="tool__edit">
                        <span className="action-span" title="Set Tool Options"
                              onClick={ () => handleToolConfigurationClick(fullTool) }>
                            <SettingsIcon />
                        </span>
                    </div>
                }
                <div className="tool__icon">
                    { (fullTool.image !== undefined) &&
                        <img src={fullTool.image.src} alt={ fullTool.image.title } />
                    }
                    { (fullTool.image === undefined) &&
                        <BuildIcon />
                    }
                </div>
                <span className="tool__name" >{ data.label }</span>

            </div>

        </div>
    );
}

export default WorkflowToolNode;